// Form field options for personal information

export const DGMA_TRANSGENDER_OPTIONS = [
  { value: "PreferNotToSay", label: "Prefer not to say" },
  { value: "Yes",            label: "Yes" },
  { value: "No",             label: "No" },
];

export const DGMA_SEXUAL_ORIENTATIONS_OPTIONS = [
  { value: "PreferNotToSay",          label: "Prefer not to say" },
  { value: "Asexual",                 label: "Asexual" },
  { value: "Bisexual",                label: "Bisexual" },
  { value: "Heterosexual",            label: "Heterosexual" },
  { value: "GayMan",                  label: "Gay man" },
  { value: "LesbianOrGayWoman",       label: "Lesbian or gay woman" },
  { value: "Pansexual",               label: "Pansexual" },
  { value: "Queer",                   label: "Queer" },
  { value: "Questioning",             label: "Questioning" },
  { value: "OtherSexualOrientation",  label: "Other sexual orientation" },
];

export const DGMA_RELIGION_OPTIONS = [
  { value: "PreferNotToSay", label: "Prefer not to say" },
  { value: "Agnostic",       label: "Agnostic" },
  { value: "Atheist",        label: "Atheist / no religious belief" },
  { value: "Buddhist",       label: "Buddhist" },
  { value: "Charedi",        label: "Charedi" },
  { value: "Christian",      label: "Christian" },
  { value: "Hindu",          label: "Hindu" },
  { value: "Jewish",         label: "Jewish" },
  { value: "Muslim",         label: "Muslim" },
  { value: "SecularBeliefs", label: "Secular Beliefs" },
  { value: "Sikh",           label: "Sikh" },
  { value: "Spiritual",      label: "Spiritual" },
  { value: "Other",          label: "Other" },
];

export const DGMA_DISABILITY_OPTIONS = [
  { value: "PreferNotToSay", label: "Prefer not to say" },
  { value: "Yes",            label: "Yes" },
  { value: "No",             label: "No" },
];
